import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../utility/Utility";
import ReactPaginate from "react-paginate";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

function AssignAgentPage() {
    const { requestId } = useParams();
    const navigate = useNavigate();
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const rowsPerPage = 10;

    // Fetch available agents with pagination and search
    const fetchAgents = async () => {
        setLoading(true);
        try {
            const response = await postData("api/users/list", {
                limit: rowsPerPage,
                page: currentPage + 1,
                search: searchTerm,
                role: "agent"
            });

            if (response?.success) {
                setAgents(response.data.users);
                setTotalPages(response.data.totalPages);
            } else {
                toast.error(response?.message || "Failed to fetch agents");
            }
        } catch (error) {
            toast.error("Error fetching agents");
            console.error("Fetch agents error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Handle agent search
    const handleSearch = (e) => {
        e.preventDefault();
        setCurrentPage(0);
        fetchAgents();
    };

    // Handle agent page change
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    // Submit approve with agent assignment
    const submitApprove = async () => {
        if (!selectedAgent) {
            toast.error("Please select an agent to assign");
            return;
        }

        try {
            const response = await postData(`api/users/process-deletion`, {
                requestId: requestId,
                assignId: selectedAgent,
                status: "approved"
            });

            if (response?.success) {
                toast.success("Request approved and assigned successfully");
                navigate(-1); // Navigate back to main page
            } else {
                throw new Error(response?.message || "Failed to approve request");
            }
        } catch (error) {
            toast.error(error.message);
            console.error("Approve error:", error);
        }
    };

    useEffect(() => {
        fetchAgents();
    }, [currentPage]);

    return (
        <div className="content-page">
        <CustomLoader loading={loading} />
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="content">
                <div className="container-fluid">
                <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
              <div className="flex-grow-1">
                <div className="page-title-box">
                  <h4 className="mb-1">Assign Agent for Request #{requestId}</h4>
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">Manage Delete Requests</li>
                    <li className="breadcrumb-item active">Assign Agent</li>
                  </ol>
                </div>
              </div>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => navigate(-1)}
                  disabled={loading}
                  aria-label="Go Back"
                >
                  <i className="fas fa-arrow-left me-1"></i> Back
                </button>
              </div>
            </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={handleSearch}>
                                        <div className="row g-3 align-items-center">
                                            <div className="col-md-12 col-lg-4">
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control ps-4"
                                                        placeholder="Search agents by name, email or phone..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                    <span className="input-group-text">
                                                        <i className="mdi mdi-magnify"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-lg-3 d-flex gap-2">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <span className="spinner-border spinner-border-sm me-1"></span>
                                                    ) : null}
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    <div className="mt-4">
                                        <h5 className="mb-3">Available Agents</h5>
                                        {loading ? (
                                            <div className="text-center py-5">
                                            </div>
                                        ) : agents.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>ID</th>
                                                            <th>Unique ID</th>
                                                            <th>Name</th>
                                                            <th>Email</th>
                                                            <th>Phone</th>
                                                            <th>Referral Code</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {agents.map((agent) => (
                                                            <tr key={agent._id}>
                                                                <td>
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="agentSelection"
                                                                            id={`agent-${agent._id}`}
                                                                            checked={selectedAgent === agent._id}
                                                                            onChange={() => setSelectedAgent(agent._id)}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>{agent._id}</td>
                                                                <td>{agent.uniqueId}</td>
                                                                <td>{agent.fullName}</td>
                                                                <td>{agent.email}</td>
                                                                <td>{agent.mobile}</td>
                                                                <td>{agent.referralCode}</td>

                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() => setSelectedAgent(agent._id)}
                                                                    >
                                                                        Select
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                {/* Pagination */}
                                                {totalPages > 1 && (
                                                    <ReactPaginate
                                                        previousLabel={<i className="mdi mdi-chevron-left"></i>}
                                                        nextLabel={<i className="mdi mdi-chevron-right"></i>}
                                                        breakLabel="..."
                                                        breakClassName="page-item"
                                                        breakLinkClassName="page-link"
                                                        pageCount={totalPages}
                                                        marginPagesDisplayed={2}
                                                        pageRangeDisplayed={5}
                                                        onPageChange={handlePageChange}
                                                        containerClassName="pagination pagination-rounded justify-content-end mt-3"
                                                        pageClassName="page-item"
                                                        pageLinkClassName="page-link"
                                                        previousClassName="page-item"
                                                        previousLinkClassName="page-link"
                                                        nextClassName="page-item"
                                                        nextLinkClassName="page-link"
                                                        activeClassName="active"
                                                        forcePage={currentPage}
                                                    />
                                                )}
                                            </div>
                                        ) : (
                                            <div className="alert alert-info">
                                                No agents found matching your search. Try a different search term.
                                            </div>
                                        )}
                                    </div>

                                    {selectedAgent && (
                                        <div className="mt-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h5>Selected Agent</h5>

                                                    <p className="mb-1">
                                                    <strong>Request ID:</strong> {requestId}
                                                    </p>
                                                    <p className="mb-1">
                                                    <strong>ID:</strong> {agents.find(a => a._id === selectedAgent)?._id}
                                                    </p>
                                                    <p className="mb-1">
                                                        <strong>Name:</strong> {agents.find(a => a._id === selectedAgent)?.fullName}
                                                    </p>
                                                    <p className="mb-1">
                                                        <strong>Email:</strong> {agents.find(a => a._id === selectedAgent)?.email}
                                                    </p>
                                                    <p className="mb-0">
                                                        <strong>Phone:</strong> {agents.find(a => a._id === selectedAgent)?.mobile}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="mt-4 d-flex justify-content-end gap-2">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => navigate(-1)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={submitApprove}
                                            disabled={!selectedAgent || loading}
                                        >
                                            {loading ? (
                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                            ) : null}
                                            Approve and Assign
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AssignAgentPage;